// «Рынок → Розница»: средние потребительские цены Росстата, ₽ за кг.
// Строка — позиция (группа вида × разделка × термосостояние), колонки — годы
// (простое среднее месяцев) и последние месяцы.

import type { RetailSeries } from '../api'

export interface RetailRow {
  item_key: string
  species: string
  processing: string
  thermal: string
  pack: string | null
  name_ru: string
  name_en: string
  years: Record<number, { rub: number; months: number }>
  months: Record<string, number>
}

export function retailRows(data: RetailSeries): RetailRow[] {
  const rows = new Map<string, RetailRow>()
  for (const it of data.items) rows.set(it.item_key, { ...it, years: {}, months: {} })
  for (const y of data.years) {
    const r = rows.get(y.item_key)
    if (r) r.years[y.year] = { rub: y.rub_per_kg, months: y.months }
  }
  for (const m of data.months) {
    const r = rows.get(m.item_key)
    if (r) r.months[m.month] = m.rub_per_kg
  }
  return [...rows.values()].sort((a, b) =>
    a.species.localeCompare(b.species) || a.item_key.localeCompare(b.item_key))
}

export function retailMonths(data: RetailSeries, n: number): string[] {
  return [...new Set(data.months.map((m) => m.month))].sort().slice(-n)
}

export function retailYears(data: RetailSeries): number[] {
  return [...new Set(data.years.map((y) => y.year))].sort()
}
